//@flow
import React from 'react';
import moment from 'moment';
import type { Node } from 'react';
import { Button, ButtonGroup, Col, Row } from 'reactstrap';

import PriceWithPromoCode from '../../components/PromoCode/PriceWithPromoCode';

type Props = {
  startDate: string,
  unitPrice?: number,
  numberOfDays: number,
  pax: number,
  totalPrice: number,
  onSubmit: Function,
  buttonText: string,
  buttonDisabled: boolean,
  ImportantNote?: Node | null,
};

export default function ReviewYourBooking({
  unitPrice,
  numberOfDays = 1,
  pax = 1,
  startDate = '',
  onSubmit = () => {},
  totalPrice,
  buttonText = 'BUY TREK',
  buttonDisabled = false,
  ImportantNote = null,
}: Props) {
  const endDate = moment(startDate)
    .add(Number(numberOfDays) - 1, 'd')
    .format('YYYY-MM-DD');

  const formatWithChar = (date: string) => moment(date).format('DD MMM');
  return (
    <div className="widget-wrap diff-color">
      <Row>
        <Col xs="12">
          <h6 className="sub-title text-left">Review Your Booking</h6>
          <ul className="review-booking">
            {unitPrice && (
              <li>
                <h3>$ {Number(unitPrice).toLocaleString()}</h3>
                <small>per person</small>
              </li>
            )}
            <li>
              <h3>
                {numberOfDays} {numberOfDays === 1 || numberOfDays === 0 ? 'day' : 'days'}
              </h3>
              <small>{`${formatWithChar(startDate)} - ${formatWithChar(endDate)}`}</small>
            </li>
            <li>
              <h3>{pax} people</h3>
            </li>
          </ul>
          <hr />
        </Col>
        <Col xs="12">
          <PriceWithPromoCode totalPrice={totalPrice} />
          <hr />
        </Col>
        <Col className="button-inline text-center">
          <ButtonGroup>
            <Button color="yellow" onClick={onSubmit} disabled={buttonDisabled}>
              {buttonText}
            </Button>
          </ButtonGroup>

          {ImportantNote ? (
            <ul className="hilight-note text-left">{ImportantNote}</ul>
          ) : null}
        </Col>
      </Row>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ReviewYourBooking/ReviewYourBooking.js